import { VueInstanceProxy } from "./useVueInstance";

const useRouter = () => {
  const _instance = VueInstanceProxy();
  return _instance.$router;
};

export default useRouter;
